<template>
    <AisRatingMenu :max="6" :attribute="attribute" v-slot="{
            items, refine, createURL, sendEvent
        }">

            <filter-collapse
                :title="label"
                v-show="items.length > 0"
                :is-open="isOpen"
            >
                <div class="algolia-listing-filters__filter-items-checkbox">
                    <div
                        v-for="(item, index) in items"
                        :key="item.value"
                        class="algolia-listing-filters__filter-item-wrapper"
                    >
                        <label
                            class="algolia-listing-filters__filter-item-checkbox-wrapper"
                            :for="`${attribute}_${index}`"
                            @change="refine(item.value)"
                        >
                            <div class="d-flex align-items-center">
                                <input
                                    :id="`${attribute}_${index}`"
                                    type="checkbox"
                                    :checked="item.isRefined"
                                    hidden
                                    class="algolia-listing-filters__filter-item-checkbox"
                                />
                                <span
                                    class="algolia-listing-filters__filter-item-checkbox-checkmark"
                                ></span>
                                <span
                                    class="algolia-listing-filters__filter-item-label test"
                                >
                                    <span
                                        v-for="(full, index) in item.stars"
                                        v-show="index != (item.stars.length -1)"
                                        class=" algolia-listing-filters__filter-item-star-icon"
                                        :key="index"
                                    >
                                        <i
                                            :class="
                                                full
                                                    ? 'fa fa-star'
                                                    : 'far fa-star'
                                            "
                                        ></i>
                                    </span>
                                </span>
                            </div>
                            <span
                                v-if="showItemCount"
                                class="algolia-listing-filters__filter-item-count"
                            >
                                ({{ item.count.toLocaleString() }})
                            </span>
                        </label>
                    </div>
                </div>
            </filter-collapse>
    </AisRatingMenu>
</template>

<script>
import { AisCurrentRefinements, AisRatingMenu } from "vue-instantsearch/vue3/es";
import FilterCollapse from "./FilterCollapse";

export default {
    components: {
        AisRatingMenu,
        AisCurrentRefinements,
        FilterCollapse
    },
    props: {
        attribute: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        isMobileStyling: {
            type: Boolean,
            default: false
        },
        showItemCount: {
            type: Boolean,
            default: true
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            includedAttributes: [this.attribute],
            showAll: false
        };
    }
};
</script>
